import type * as React from 'react';
import { cn } from '../utils';

export interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

export function SectionHeader({ title, subtitle, actions, className }: SectionHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 py-2', className)}>
      <div className="flex min-w-0 flex-col">
        <h2 className="text-[14px] font-semibold text-[var(--color-text-primary)] leading-snug">
          {title}
        </h2>
        {subtitle ? (
          <p className="mt-0.5 text-[12px] text-[var(--color-text-secondary)]">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}
